<template>
  <table>
    <caption>대상자별 일반소식 목록</caption>
    <thead>
      <tr>
        <th>번호</th>
        <th>제목</th>
        <th>내용</th>
        <th>작성자</th>
        <th>작성시간</th>
        <th>최초전송시간</th>
        <th>확인시간</th>
        <th>스피커알림</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="rowData in sourceList">
        <td>{{rowData.id}}</td>
        <td>{{rowData.boardTitle}}</td>
        <td>{{rowData.boardContent}}</td>
        <td>{{rowData.userName}}</td>
        <td>{{$utils.timeText(rowData.createDate)}}</td>
        <td>{{$utils.timeText(rowData.pushFirstDate)}}</td>
        <td>{{$utils.timeText(rowData.readDate)}}</td>
        <td>
          <PushStatusColumn
            displayType="RCP"
            :statusCode="rowData.pushStatus"
            :failMessageCode="rowData.pushFailDetail"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import newsMixin from "$views/News/_mixin";
export default {
  mixins: [newsMixin],
  props: {
    sourceList: Array
  }
};
</script>

<style>
</style>